import { Card, CardBody, Form } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import { Discard, Post, PostEditTitle } from "../../../../../Utils/Constants";
import PostEditForm from "./PostEditForm";

export default function PostEdit() {
  return (
    <Card>
      <CommonCardHeader headClass="pb-0" title={PostEditTitle} />
      <CardBody className="add-post">
        <PostEditForm />
        <Form className="m-b-20 custom-dropzone">
          <CommonFileUpload />
        </Form>
        <div className="btn-showcase text-end">
          <Btn color="primary">{Post}</Btn>
          <Btn color="light">{Discard}</Btn>
        </div>
      </CardBody>
    </Card>
  );
}
